
import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from "app/authorized-http.service";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";
import { UtilsService } from "app/services/utils.service";
import { UserResource } from "app/resources/user/user-resource";
import { CompanyListResource } from "app/resources/company/company-list-resource";
import { RoleListResource } from "app/resources/role/role-list-resource";
import { UserChangePasswordResource } from "app/resources/user/UserChangePasswordResource";
import { AdminProfileResource } from "app/models/AdminProfileResource";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class MyProfileService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  getUserProfile(url): Observable<UserResource> {
    return this.http.get<UserResource> (environment['url'] + url)
  }

  getAllCompany(url): Observable<CompanyListResource> {
    return this.http.get<CompanyListResource> (environment['url'] +url)
  }

  getUserRoles(url): Observable<RoleListResource> {
    return this.http.get<RoleListResource>(environment['url'] +url)
  }

  editUser(url,body): Observable<UserResource> {
    return this.http.post<UserResource> (environment['url'] +url, body)
  }

  changePassword(url,body): Observable<UserChangePasswordResource> {
    return this.http.post<UserChangePasswordResource> (environment['url'] +url, body)
  }

 /*  getAdminProfile(url): Observable<AdminProfileResource> {
    return this.http.get<AdminProfileResource>(environment['url'] + url)
  } */

}
